import { useEffect, useState } from "react";
import { HappyTailListResponseSimplified } from "./types.ts";
import { fetchHappyTailList } from "./service.ts";
import Skeleton from "react-loading-skeleton";
import { AdoptedPetPreview } from "./AdoptedPetPreview.tsx";

export function AdoptedPetsGridWrapper() {
  const [response, setResponse] = useState<
    HappyTailListResponseSimplified | undefined
  >();
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    (async () => {
      setIsFetching(true);
      const res = await fetchHappyTailList({
        pSpeciesID: 0,
        pOrderBy: "AnimalID",
        pCount: 200,
      });
      setResponse(res);
      setIsFetching(false);
    })();
  }, []);

  if (isFetching || !response) {
    return <Skeleton count={4} />;
  }

  response.items.sort((a, b) => a.name.localeCompare(b.name)); // sort alphabetically

  if (!response) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-12 max-w-[1000px] lg:max-w-[1280px] mx-auto">
      {(response.items ?? []).map((item) => (
        <AdoptedPetPreview key={item.animalId} item={item} />
      ))}
    </div>
  );
}
